import { lazy } from 'react';

// 维权列表
const SafeguardList = lazy(() => import('pages/safeguardList'));
// 维权详情
const SafeguardDetail = lazy(() => import('pages/safeguardDetail'));

const router = {
    path: '/safeguard',
    name: '维权管理',
    icon: 'safety',
    permission: 105,
    children: [
        {
            path: 'list',
            name: '维权列表',
            icon: 'safety',
            permission: 10501,
            component: SafeguardList,
        },
        {
            path: 'detail',
            name: '维权详情',
            icon: '_space',
            permission: 10501,
            hideInMenu: true,
            component: SafeguardDetail,
        },
    ],
};

export default router;
